import React, { Component } from "react";
import LOOKUP from "constants/lookup";
import GenericTable from "screens/components/advanced/GenericTable";
import { mapDbInventory } from "utils/mappers";
import { connect } from "react-redux";
// import LinearProgress from "material-ui/LinearProgress";
import LinearProgress from '@mui/material/LinearProgress';
import Button from 'screens/components/basic/Button';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import { getInvetory } from 'actions/DashboardActions' 
class Inventory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryAll: true,
      categoryCannabis: false,
      categorynonCannabis: false
    }

    this.clickAll = this.clickAll.bind(this);
    this.clickCannabis = this.clickCannabis.bind(this);
    this.clickNonCannabis = this.clickNonCannabis.bind(this);
  }

  clickAll() {
    this.props.handleInventoryFilter(0);
    this.setState({
      categoryAll: true,
      categoryCannabis: false,
      categorynonCannabis: false
    })
  }

  clickCannabis() {
    this.props.handleInventoryFilter(1);
    this.setState({
      categoryAll: false,
      categoryCannabis: true,
      categorynonCannabis: false
    });
  }

  clickNonCannabis() {
    this.props.handleInventoryFilter(2);
    this.setState({
      categoryAll: false,
      categoryCannabis: false,
      categorynonCannabis: true
    });
  }

  render() {
    const inventory = this.props.inventory;
    return (
      <div id="chart9" className="item col-4-p-0">
        <DashDialog
          text="Items Running Low"
          link="/report/reorder-report"
          classicClass="bg-ClassicRed"
          isReport={true}
          refreshAction={() => this.props.getInventory({ branchId: this.props.branchId, Category: 0 })} />
        {this.props.loading ? (
          <LinearProgress variant="indeterminate" />
        ) : (
          <div className="inventory_height">
            <div className="list-table-last">
              {inventory.length > 0 ? (
                <GenericTable
                  className="table_center no-header"
                  multiSelectable={false}
                  enableSelectAll={false}
                  selectable={false}
                  stripedRows={true}
                  columns={LOOKUP.inventory.dashBoardTable}
                  rows={mapDbInventory(inventory)}
                />
              ) : (
                <h2 className="table_msg">ITEMS INSIDE INVENTORY ARE GOOD</h2>
              )}

              <div>
                <Button name="buttonSave"
                  type="dashboardButton"
                  className={this.state.categoryAll ? "db-btns btn-selected btnNewBrandPOS noPaddingBtn" : "db-btns btnNewBrandGray noPaddingBtn"}
                  label="All"
                  onTouchTap={this.clickAll}
                />
                <Button name="buttonSave"
                  type="dashboardButton"
                  className={this.state.categoryCannabis ? "db-btns db-btns2 btn-selected btnNewBrandPOS noPaddingBtn" : "db-btns db-btns2 btnNewBrandGray noPaddingBtn"}
                  label="Cannabis"
                  onTouchTap={this.clickCannabis}
                />
                <Button name="buttonCancel"
                  type="dashboardButton"
                  className={this.state.categorynonCannabis ? "db-btns db-btns2 btn-selected btnNewBrandPOS noPaddingBtn" : "db-btns db-btns2 btnNewBrandGray noPaddingBtn"}
                  label="NonCannabis"
                  onTouchTap={this.clickNonCannabis}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.common.dbInventory > 0,
    branchId: state.common.branchId
  };
}

function mapDispatchToProps(dispatch){
  return {
    getInventory: (model) => dispatch(getInvetory(model, true)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
